import React, { memo, forwardRef } from "react";
const SvgTendsto = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M6 16h18"
      />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 9c0 5 8 7 8 7s-8 2-8 7"
      />
    </svg>
  );
});
SvgTendsto.displayName = "SvgTendsto";
const MemoForwardRef = memo(SvgTendsto);
export default MemoForwardRef;
